export default __webpack_public_path__ + "rcodea800cf.png";